module.exports = {

    save:       'Save',
    saved:      'Saved',
    close:      'Close',
    next:       'Next',
    prev:       'Previous',
    cancel:     'Cancel',
    back:       'Go back',
    thanks:     'Thank you!',
    send:       'Send',
    show_less:  'Show less',
    show_more:  'Show more',
    perfect:    'Perfect!',
    awesome:    'Great!',
    hello_im:   "Hello, I'm {0}",
    hello:      'Hello',

    labels : {
        user_name:       'Your name',
        user_email:      'Your email',
        user_phone:      'Your phone number',
        comments:        'Additional comments',
        date:            'Select a date',
        budget_from:     'From',
        budget_to:       'To',
        amount:          'Amount',
        currency:        'Currency',
        selection:       'Your selection',
        choice_one:      'Select one',
        choice_city:     'Select a city',
        choice_event:    'Select an event',
        days_count:      '{count} day | {count} days',
        days_more:       'more than {count} day | more than {count} days',
        day_x:           'Day {0}',
        total:           'Total',
        hostesses_count: '{count} hostess | {count} hostesses',
        hostesses_more:  'more than {count} hostess | more than {count} hostesses',
        guests:          '{count} guest | {count} guests',
        services:        '{count} service | {count} services',
        meals:           '{count} meal | {count} meals',
        period:          '{count} period | {count} periods',
        city:            'City',
        web:             'Web Page',
    },

    terms_label:       'I have read and accept the {0}',
    terms_link_label:  'Privacy Policy',

    errors : {

        required:       'required field',
        area:           'Stand size is required',
        user_name:      'A name is required',
        user_email:     'A valid email is required',
        user_phone:     'A phone is required',
        select_element: 'Select one',
        estimate:       'An estimate is requierd',
    },

    rq : {

        stands : {

            labels : {
                city:             'In which city do you need the stand',
                event:            'In which trade show do you exhibit?',
                size:             'Stand size',
                price_rank:       'Price range',
                price_rank_help:  'To select the right materials for the design and construction of your stand please let us know which price range works best for you.',
            },

            thanks : {

                text:       'In 48h we will send you a selection of the best proposals',
                text_alt_1: 'Based on the information the approximate budget to build a {0} stand in {1} is around {2}.',
                text_alt_2: 'Onced booked the space in the exibition do not hesitate to contact us again if you need a personalised stand.',
                text_alt_3: 'Have a great weekend!',
            },

            upload : {
                text:       'Upload your own design',
                supported : 'We accept pdf, jpg, cad or zip files ({size} MB max per file)'
            },

            options_has_design: {

                0 : 'Design + Assembly',
                1 : 'Just assembly',
                2 : 'Other services'
            },

            page_start_title:     'Stand request',
            page_start_subtitle:  'Features',
            page_start_options_has_design : {

                0: 'I need the stand design,construction and assembly',
                1: 'I already have a stand design, I just need the construction and assembly',
                2: 'Others',
            },

            page_user_title:        'Your contact information',
            page_user_subtitle:     '',

            page_price_title:       'Price range',
            page_price_subtitle :   '',

            page_upload_title :     'Great! Please send us your design to give you an estimate',
            page_upload_subtitle:   '',

            page_space_title:       'Have you already booked the space in the tradeshow?',
            page_space_subtitle:    '',
            page_space_options : {

                0: 'No, I´m still evaluating and I need to know the stand price',
                1: 'Yes, I already booked the space and location',
            },

            page_type_title:        'Select which type of stand are you looking for',
            page_type_subtitle:      '',
            page_type_options: {
                design:  'Design Stand',
                modular: 'Modular Stand',
                mixed :  'Mixed Stand',
                display: 'Display Stand',
                none:    'I don´t know yet'
            },

            page_properties_title:     '¿What elements do you need in the stand?',
            page_properties_subtitle : 'Select as many as you need',
            page_properties_options: {
                counter:            'Counter',
                furniture:          'Furniture',
                multimedia:         'Multimedia',
                closedMeetingRoom:  'Closed meeting room',
                openMeetingRoom:    'Open meeting room',
                spaceStorage:       'Space storage',
                cateringArea:       'Catering area',
                hangingElements:    'Hanging elements',
            },

            page_staff_title:               'How many employees will be in the stand during the event?',
            page_staff_subtitle:            'Specify the number of employees, what position they have, that are going to be in the stand. This information is helpfull for designing the stand. Example: manager + 3 sales person + hostesses',

            page_price_relevance_title :    'How relevant is the price in your purchase decision?',
            page_price_relevance_subtitle : 'Price and design are two sides of the same coin, with a bigger budget more investment in the design and the materials to build the stand. Tell us how important is each of this aspects',
            page_price_relevance_options  : {

                label1 : 'Relevance:',
                label2 : 'Minimum',
                label3 : 'Low',
                label4 : 'Medium',
                label5 : 'High',
                label6 : 'Maximum',
                label7 : 'Price',
                label8 : 'Design',
            },

            page_price_max_title:    'Budget and currency',
            page_price_max_subtitle: 'You selected the price as the most important aspect. What is the maximun budget?',

            page_upload_alt_title:    'Do you want to attach some design, idea or concept of how your stand should be? This would help us to understand better what do you have in mind.',
            page_upload_alt_subtitle: '',
        },

        hostesses : {

            thanks : {
                title : 'Thanks!',
                text  : 'Please send your CV to CV.hostesses@neventum.com and we will share with the hostesses agencies partners',
            },

            create : {

                1 : {
                    title         : 'Hostesses Request',
                    subtitle      : 'In which city and exhibition do you need the hostesses',
                    label1        : 'In which city do you need the hostesses?',
                    label2        : 'Enter the name of the event',
                    placeholder   : 'Write or select an element',
                },
                2 : {
                    title         : 'Can you confirm this information, please?',
                    label1        : 'Confirm city',
                    label2        : 'Confirm start date',
                },
                3 : {
                    title         : 'Hostesses Request',
                    subtitle      : 'Contact details',
                },
                4 : {
                    title         : 'For a better service, please tell us your profile.',
                    label1        : 'I am <b>Client</b> that need to hire a hostesses agency services',
                    label2        : 'I am <b>Agency</b> that need hostesses for a client',
                    label3        : 'I am <b>Hostess</b> looking for a job and want to send my CV',
                },
                5 : {
                    title           : 'How many hostesses do you need and for how long?',
                    label1          : 'Required hostesses',
                    label2          : 'Required days',
                    label3          : 'Unfortunately we have not found the event in our database, please tell us the initial date',
                    placeholder     : 'Select',
                },

                6 : {
                    title         : 'How many hours do you need the service each day?',
                    option1       : '1 hour',
                    option2       : '{0} hours',
                    option3       : 'More than 8 hours',
                },
                7 : {
                    title         : 'How many hours do you need the service each day?',
                    option1       : '1 hour',
                    option2       : '{0} hours',
                    option3       : 'more than 8 hours',
                },
                8 : {
                    title         : 'What tasks should the hostesses do?',
                    body          : 'Example: I need image hostesses to stay at the booth and distribute flyers around the exhibition and a bilingual hostess to support the commercial team, ...',
                },
                9 : {
                    title         : 'Required language',
                    body          : 'Select or enter the required languages',
                    label1        : 'Spanish',
                    label2        : 'Italian',
                    label3        : 'French',
                    label4        : 'English',
                    label5        : 'German',
                    label6        : 'Portuguese',
                    label7        : 'Others',
                },

                errors : {
                    city              : 'Select a city',
                    event             : 'Select an event',
                    userName          : 'Enter your name',
                    userEmail         : 'Enter your email',
                    userPhone         : 'Enter your phone',
                    invalidEmail      : 'Enter a valid email address',
                    profile           : 'Select your profile',
                    countHostesses    : 'How many hostesses do you need?',
                    countDays         : 'For how many days do you need?',
                    deadline          : 'Enter the date of the event',
                    days              : 'Complete the schedule for each day',
                    hoursAvg          : 'Completa the schedule',
                    tasks             : 'What tasks should the hostesses do?',
                    langs             : 'Which language are required?',
                    otherLang        : 'Enter other language',
                }
            }
        },

        catering : {

            thanks : {
                title: 'Thank you!'
            },

            guests: 'Guests',

            1 : {
                title         : 'Catering Request',
                subtitle      : 'In which city and event dou you need the service?',
                label1        : 'In which city do you need the catering service?',
                label2        : 'Enter the name of the event',
                placeholder   : 'Select or enter the event',
            },
            2 : {
                title         : 'Catering Request',
                subtitle      : 'Contact details',
            },
            3 : {
                title:      'For how many days do you need the catering service?',
                label_days: 'days',
                label_date: 'Unfortunately we have not found the event in our database, please tell us the initial date',
            },
            4 : {
                title         : 'How many guests do you expect to have?',
            },
            5 : {
                title:  'How many guests do you expect to have daily?',
            },

            6 : {
                title         : 'How many guests do you expect to have daily?',
                guests        : 'Guests',
            },
            7 : {
                title         : 'What kind of service are you looking for?',
                title2        : 'At what time do you need the catering service?',
                label1        : 'Buffet during the event',
                label2        : 'Coffeebreak',
                label3        : 'Main Dishes',
                label4        : 'All day event',
                label5        : 'Breakfast',
                label6        : 'Lunch',
                label7        : 'Dinner',
            },
            8 : {
                title         : 'Which services do you need?',
                label1        : 'Waiters',
                label2        : 'Soft drinks and coffee',
                label3        : 'Alcoholic drinks',
                label4        : 'Food',
                label5        : 'Furniture',
                label6        : 'Kitchenware',
            },
            9 : {
                title         : 'Budget',
                label1        : 'Budget per guest',
                label2        : 'Global budget',
                text1         : 'Please tell us your maximum budget to present you the best catering option considering your price range',
                text2         : 'Please tell us your maximum budget per guest to present you the best catering option considering your price range',
            },
            10 : {
                title         : 'Do you want to add something else?',
                subtitle      : 'Aditional requirements, intolerance, special menu, ....'
            },

            labels : {

                service: {
                    buffet:      'Buffet',
                    coffeeBreak: 'Coffeebreak',
                    mainDishes:  'Main dishes',
                },
                period: {
                    allday:     'All day',
                    breakfast:  'Breakfast',
                    lunch:      'Lunch',
                    dinner:     'Dinner',
                },
                budgetType : {
                    byGuest: 'Budget per guest',
                    global : 'Global budget'
                }
            },

            errors : {
                city          : 'Select a city',
                event         : 'Select an event',
                userName      : 'Enter your name',
                userEmail     : 'Enter your email',
                userPhone     : 'Enter your phone',
                invalidEmail  : 'Enter a valid email address',
                days          : 'You must select how many days are required',
                deadline      : 'Enter the date of the event',
                guests        : 'Enter the guests number',
                daysResume    : 'Enter the guests number per day',
                guestsAvg     : 'Enter the guests number',
                period        : 'Select schedule',
                service       : 'Select a service',
                budgetType    : 'Select an option for the budget',
                budget        : 'Enter de maximun budget',
                budgetFormat  : 'The budget must be a whole number'
            }

        }
    },

    corporation : {

        suppliers : {

            page_navbar_my_brand        : 'My brand:',
            page_navbar_data            : 'Data',
            page_navbar_presentation    : 'Presentation',
            page_navbar_geo             : 'Where you work',
            page_navbar_stands          : 'My stands',
            page_navbar_office          : 'office',
            page_navbar_scopes          : 'Scope',

            page_related_is_other       : 'Create new company',
            page_related_is_this        : 'This is my company',
            page_related_created_by     : 'Profile <b>created by {0}</b> on {1}',
            page_related_not_suggested  : "My company doesn't match with the suggestions, I would like to continue with the process:",

            page_resolution_label_1     : 'Do not do <b>anything</b>, we will solve it',
            page_resolution_label_2     : '{0} will continue managing the brand but <b>I want permissions to update content, receive leads</b>, ...',
            page_resolution_label_3     : '{0} is not longer responsible for managing this content, <b>from now on I will be the responsible</b> for this',

            labels : {
                name                    : 'Company name',
                city                    : 'City',
                sector                  : 'Sector',
                address                 : 'Address',
                web                     : 'Website',
            },

            alerts : {

                group_suppliers_text_1  : '<b>Is this your company?</b>',
                group_suppliers_text_2  : 'Someone from your company has a profile on neventum - we know by the corporate mail -',
                group_suppliers_text_3  : 'We thought it was a good idea to tell you, then if is the same company you can simplify your task ;)',
                group_suppliers_text_4  : "If you were going to create this company tell us and request to, if you wish, edit permissions. If it was another company tell us and let's continue with the form.",

                other_suppliers_text_1  : '<b>Is this your company?</b>',
                other_suppliers_text_2  : 'Based on the information you filled we found similar brands on neventum.',
                other_suppliers_text_3  : "We show the following brands to avoid duplicating a one that was already created by your colleague.",
                other_suppliers_text_4  : "If you were going to create that company tell us and ask, if you wish, edit permissions. If it was another company tell us and let's continue with the form.",

                resolution_text_1        : '<b>Great!</b>',
                resolution_text_2        : 'Just we need to know who will manage the brand from now on: you, your colleague, both...',
                resolution_text_3        : 'Select an option',

            },

            page_thank_send_email       : 'We sent an email to {0} to allow the permissions you need',
            page_thank_we_wait          : 'Looking forward to hearing from you!',
            page_thank_will_help        : 'I will help you to change {0} owner, I will contact you soon to begin the process.',

        }
    },

    event : {

        page_related_from_to        : 'from {0} to {1}',
        page_related_is_this        : 'Claim Event',
        page_related_not_suggested  : "My event doesn't match with the suggestions, I would like to continue with the process:",
        page_related_is_other       : 'None of these',

        page_thank_label_1          : 'Hello {0},',
        page_thank_label_2          : 'Our content team is evaluating your request to include the event on your profile.',
        page_thank_label_3          : 'In less than 24 hours ( not including holidays ) we will solve it ;)',
        page_thank_label_4          : 'We will keep you informed and invite you to include more events',
        page_thank_label_5          : 'Greetings',
        page_thank_label_6          : 'neventum Editorial Staff',

        labels : {
        'sector'                : 'Event sector',
            'periodicity'           : 'Event periodicity',
            'scope'                 : 'Event scope',
            'name'                  : 'Event name'
        },

        periodicity : {
            mensual                 : 'Monthly',
                trimestral              : 'Quarterly',
                semestral               : 'Biannual',
                anual                   : 'Anual',
                bienal                  : 'Biennial',
                trienal                 : 'Triennial',
                cuatrienal              : 'Four year',
        },

        scopes : {
            local                   : 'Local',
                national                : 'National',
                international           : 'International',
        },

        alerts : {

            related_events_text_1 : '<b>Is this your event?</b>',
                related_events_text_2 : 'Based on the information you filled about your event, we found similar events on neventum.',
                related_events_text_3 : 'To avoid duplicating an event that is already included in the calendar we show you below.',
                related_events_text_4 : 'If you were going to create that event tell us and ask, if you wish, permission to edit it',

        },
    },

    reviews : {

        thanks : 'Thanks for sharing your opinion',

        labels : {

            rate      : 'Your general rate',
            opinion   : 'Your opinion',

            city               : 'In which city was the stand built?',
            city_stands         : 'In which city was the stand built?',
            city_catering       : 'Where was the event?',
            city_hostesses      : 'In which city did you request the hostesses?',

            worked_at           : 'When was the stand built?',
            worked_at_stands    : 'When was the stand built?',
            worked_at_catering  : 'When was the event?',
            worked_at_hostesses : 'When was the event?',

            name      : 'Your name',
            email     : 'Your email',
            anonymous : 'I want this opinion to be anonymous. My name will not be made pubic nor communicated to the supplier.',
            accept    : 'I certify that this opinion is based on my own experience and is my own opinion about this supplier, and that I don´t have any personal or commercial relationship with them, neither have offered me any kind of incentive or payment to write this opinion. I understand that neventum has zero tolerance policy with fake opinions',
            submit    : 'Submit your opinion',
        },

        help : {
            name  : 'Check the box below to be anonymus',
            email : 'This information will NEVER be public',
        },
    },

    rate : {
        label           : 'Click to rate',
        label_bad       : 'Bad',
        label_poor      : 'Poor',
        label_fair      : 'Fair',
        label_good      : 'Good',
        label_excellent : 'Excellent',
    },

    cookie : {
        text            : 'Las cookies recogen información en tu navegador web para ofrecerte una mejor experiencia online. En neventum utilizamos cookies, si continuas navegando consideramos que aceptas su uso.',
        label_accept    : 'Aceptar',
        label_info      : 'Más información',
    },

    session : {
        login :     'Log in',
        register :  'Register',
    },

    login : {
        title :                 'Welcome to neventum',
        placeholder_email :     'E-mail',
        placeholder_password :  'Password',
        signin :                'Log in',
        forget_password :       'Did you forget your password?',
        register :              'I do not have an account',
    },
};



// WEBPACK FOOTER //
// ./resources/js/i18n/en.js